// react components
import React, {
    useState,
} from 'react'
import axios from 'axios'
import {
    useDispatch,
    useSelector,
} from 'react-redux'

// data
import {
    contentTypeDataSite,
    contentTypeModelTypeSite,
    defaultReduxState,
    reduxModalErrorEventHandlerSite,
    reduxModalMainFormShowSite,
} from 'data'

// pages
import {
    AddButton825,
    Button825,
    ImageForm825,
} from 'pages'

// serializers
import {
    ContentTypeFieldTypes,
    ContentTypeSettingsTypes,
} from 'serializers/site'

// services
import {
    axiosErrorHandlerSite,
    getApiUrlSiteV2,
    getAxiosHeadersSite,
} from 'services'

// props
type DetailActionProps = {
    blockId: number
    columns?: string[]
    contentType: contentTypeModelTypeSite
    contentTypeSettings: ContentTypeSettingsTypes
    detailObject: any
    disableOrdering?: boolean
    emailContentObjectId?: number
    emailContentType?: contentTypeModelTypeSite
    exportColumns: {
        columnName: string
        columnTitle: string
        fieldOptions: ContentTypeFieldTypes | undefined
    }[]
    exportListApiUrl: string
    filterParams?: string
    hasOrdering: boolean
    inModal?: boolean
    isOrdering: boolean
    parentModelField: string
    parentObject: {
        id: number
        content_type_string: string
        content_uuid: string
        model_content_type_id: number
        profile?: any
    }
    refreshData: () => void
    setCustomColumns: (customColumns: any[]) => void
    setIsOrdering: (value: boolean) => void
    subContentType?: any
    subContentTypes?: any
    subTab?: string
}

// main
export const DetailTabAction825: React.FC<DetailActionProps> = React.memo(({
    blockId,
    columns,
    contentType,
    contentTypeSettings,
    detailObject,
    disableOrdering,
    exportColumns,
    exportListApiUrl,
    filterParams,
    hasOrdering,
    inModal,
    isOrdering,
    parentModelField,
    parentObject,
    refreshData,
    setCustomColumns,
    setIsOrdering,
    subContentType,
    subContentTypes,
    subTab,
}) => {

    const dispatch = useDispatch()
    const reduxAuth = useSelector((state: defaultReduxState) => state.reduxAuth)
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)
    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    const [emailToList, setEmailToList] = useState<string[] | undefined>(undefined)
    const [isImageFormOpen, setIsImageFormOpen] = useState(false)
    const [isSelectionFormOpen, setIsSelectionFormOpen] = useState(false)
    const [subContentTypesIsImageForm, setSubContentTypesIsImageForm] = useState(false)

    if (!parentObject.id) return null

    function onShowModalForm(bulk?: boolean, subContentTypeId?: number) {
        try {
            if (bulk) {
                const defaultFields = {
                    [parentModelField]: parentObject,
                }
                dispatch(reduxModalMainFormShowSite({
                    contentType,
                    cssClass: 'form-container-modal',
                    refreshData,
                    customformState: {
                        fieldsForm: {
                            formJson: [
                                'payload',
                            ],
                        },
                    },
                    defaultFields,
                    formComponent: 'CustomFormModal',
                    objectId: 'new',
                    profileObject: parentObject.profile,
                }))
            } else {
                const defaultFields = {
                    [parentModelField]: parentObject,
                }
                // TODO check if dynamic possible
                if (parentModelField.includes('object_id')) {
                    /// @ts-ignore
                    defaultFields[parentModelField] = parentObject.id
                    defaultFields['content_type'] = {
                        id: parentObject.model_content_type_id,
                        /// @ts-ignore
                        name: parentObject.content_type_string,
                    }
                }
                // TODO
                if (subContentTypeId) {
                    /// @ts-ignore
                    defaultFields.sub_content_type = { id: subContentTypeId, name: subContentTypeId }
                } else if (subContentType) {
                    defaultFields['sub_content_type'] = {
                        id: subContentType.id,
                        /// @ts-ignore
                        name: subContentType.id,
                    }
                }
                if (filterParams?.includes('asset_custom_category')) {
                    // @ts-ignore
                    defaultFields['asset_custom_category'] = filterParams.split('&').find((param) => param.includes('asset_custom_category')).split('=')[1]
                }
                dispatch(reduxModalMainFormShowSite({
                    contentType,
                    contentTypeSettings,
                    cssClass: 'form-container-modal',
                    defaultFields,
                    formComponent: 'FormModal',
                    objectId: 'new',
                    profileObject: parentObject.profile,
                    refreshData,
                }))
            }
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'DetailTabAction825',
                'onShowModalForm',
            ))
        }
    }

    return (
        <div className='detail-tab-action-825 DetailTabAction825'>
            {hasOrdering && (
                <Button825
                    disabled={disableOrdering}
                    edit={false}
                    fill='outline'
                    onClick={() => setIsOrdering(!isOrdering)}
                    padding='0 0 0 10px'
                    size='x-small'
                    text={!isOrdering ? reduxText[10173] : reduxText[8334]}
                />
            )}
            {!contentTypeSettings.meta.disableFormAdd && (
                <AddButton825
                    inModal={inModal}
                    onShowModalForm={(subContentTypeId?: number, isImage?: boolean) => {  // TODO dynamic
                        if (subContentTypeId) {
                            if (isImage) {
                                // @ts-ignore
                                setSubContentTypesIsImageForm({ id: subContentTypeId, name: subContentTypeId })
                            } else {
                                onShowModalForm(false, subContentTypeId)
                            }
                        } else if (subContentType) {
                            if (subContentType.isImage) {
                                setIsImageFormOpen(true)
                            } else {
                                onShowModalForm()
                            }
                        } else if ([contentTypeDataSite['datapool_asset'], contentTypeDataSite['event_eventimage'], contentTypeDataSite['staff_staffmessageimage']].includes(contentTypeSettings.meta.model_content_type_id)) {
                            setIsImageFormOpen(true)
                        } else if ([contentTypeDataSite['setup_contenttypefieldlist']].includes(contentTypeSettings.meta.model_content_type_id)) {
                            setIsSelectionFormOpen(true)
                        } else {
                            onShowModalForm()
                        }
                    }}
                    size='x-small'
                    subContentTypes={subContentTypes}
                />
            )}
            {isImageFormOpen && (
                <ImageForm825
                    contentType={contentType}
                    detailObject={detailObject}
                    filterParams={filterParams}
                    refreshData={refreshData}
                    setIsOpen={setIsImageFormOpen}
                    subContentType={subContentType}
                />
            )}
            {subContentTypesIsImageForm && (
                <ImageForm825
                    contentType={contentType}
                    detailObject={detailObject}
                    filterParams={filterParams}
                    refreshData={refreshData}
                    setIsOpen={setSubContentTypesIsImageForm}
                    subContentType={subContentTypesIsImageForm}
                />
            )}
        </div>
    )
})
